import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import SajuForm from './SajuForm';
import { useSajuApi } from '../../../../hooks/useSajuApi';
import SajuResult from './SajuResult';

const SajuService = () => {
  const navigate = useNavigate();
  const { loading, error, analyzeSaju } = useSajuApi();
  const [result, setResult] = useState(null);

  const handleSubmit = async (formData) => {
    try {
      const response = await analyzeSaju(formData);
      setResult(response);
    } catch (error) {
      console.error('사주 분석 오류:', error);
    }
  };

  return (
    <>
      <Helmet>
        <title>AI 사주풀이 | Recamix</title>
        <meta name="description" content="AI가 분석하는 당신의 사주팔자" />
      </Helmet>
      
      <div className="container mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/services')}
          className="mb-4 px-4 py-2 text-gray-600 hover:text-gray-800"
        >
          ← 돌아가기
        </button>
        
        <h1 className="text-3xl font-bold mb-4">AI 사주풀이</h1>
        <p className="text-gray-600 mb-8">
          생년월일과 태어난 시간을 바탕으로 사주팔자를 분석해드립니다.
        </p>

        <div className="max-w-3xl mx-auto">
          {error && (
            <div className="mb-4 p-4 bg-red-50 text-red-600 rounded-lg">
              {error.message}
            </div>
          )}
          
          {loading ? (
            <div className="flex items-center justify-center p-8">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
            </div>
          ) : (
            <SajuForm onSubmit={handleSubmit} />
          )}

          {result && !loading && (
            <div className="mt-8">
              <SajuResult result={result} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SajuService; 